import {graphql} from 'react-relay'

export const query = graphql`
  query AgentsSidebarQuery {
    ...AgentsPagesCanViewAgentDetailsFragment
  }
`
